import { GzSelectedListItemGeneratorWebComponent } from './component/GzSelectedListItemGeneratorWebComponent';

export { GzSelectedListItemGeneratorWebComponent };
